import { IMainWrapper } from './StatusPill.types';

export const getTextColor = ({ status, theme }: IMainWrapper) => {
  switch (status) {
    case 'request.status.pending':
    case 'request.status.confirming_details':
    case 'request.status.sourcing':
    case 'listing.status.pending':
    case 'listing.status.confirming_details':
    case 'listing.status.sourcing':
      return theme?.palette.neutral[500];
    case 'request.status.accepted':
    case 'request.status.cancelled':
    case 'listing.status.accepted':
    case 'listing.status.cancelled':
      return theme?.palette.common.white;
    default:
      return theme?.palette.neutral[700]; // Fallback color
  }
};

export const getBackgroundColor = ({ status, theme }: IMainWrapper) => {
  switch (status) {
    case 'request.status.pending':
    case 'listing.status.pending':
      return theme?.palette.tertiary[500];
    case 'request.status.confirming_details':
    case 'request.status.sourcing':
    case 'listing.status.confirming_details':
    case 'listing.status.sourcing':
      return theme?.palette.secondary[600];
    case 'request.status.cancelled':
    case 'listing.status.cancelled':
      return theme?.palette.neutral[400];
    case 'request.status.accepted':
    case 'listing.status.accepted':
      return theme?.palette.primary[500];
    default:
      return theme?.palette.neutral[50]; // Fallback color
  }
};
